import React from 'react';
import { isMobile } from 'react-device-detect';
import { usePreferences } from './Preferences/PreferencesContext';
import { getThemeColors } from '../helpers/themeColors';
import NavigationBar from './Shared/NavigationBar';

const SPACING = {
  containerMaxWidth: 800,
  containerPaddingDesktop: 40,
  containerPaddingMobile: 16,
  sectionMarginBottom: 40,
  headingMarginBottom: 12,
  paragraphMarginBottom: 8,
};

const FONT = {
  title: 28,
  titleMobile: 22,
  heading: 18,
  body: 15,
  bodyLineHeight: 1.7,
};

const buildColors = (theme) => {
  const t = getThemeColors(theme);
  return {
    text: t.textPrimary,
    body: t.textSecondary,
    link: t.accentPrimary,
    divider: t.borderPrimary,
  };
};

// Issue 3: static style objects at module scope — no dependency on COLORS or reactive values
const containerStyle = {
  maxWidth: SPACING.containerMaxWidth,
  margin: '0 auto',
  padding: isMobile ? SPACING.containerPaddingMobile : SPACING.containerPaddingDesktop,
};

const sectionStyle = {
  marginBottom: SPACING.sectionMarginBottom,
};

const Legal = () => {
  const { preferences } = usePreferences();
  const COLORS = buildColors(preferences.theme);

  const titleStyle = {
    fontSize: isMobile ? FONT.titleMobile : FONT.title,
    color: COLORS.text,
    marginBottom: SPACING.sectionMarginBottom,
  };

  const headingStyle = {
    fontSize: FONT.heading,
    color: COLORS.text,
    marginBottom: SPACING.headingMarginBottom,
    paddingBottom: SPACING.paragraphMarginBottom,
    borderBottom: `1px solid ${COLORS.divider}`,
  };

  const bodyStyle = {
    fontSize: FONT.body,
    color: COLORS.body,
    lineHeight: FONT.bodyLineHeight,
    marginBottom: SPACING.paragraphMarginBottom,
  };

  const linkStyle = {
    color: COLORS.link,
  };

  return (
    <>
      <NavigationBar />
      <div style={containerStyle}>
        <h1 style={titleStyle}>Legal Notices</h1>

        <div style={sectionStyle}>
          <h2 style={headingStyle}>Fan Content Notice</h2>
          <p style={bodyStyle}>
            CollectNDeck is unofficial Fan Content permitted under the Fan Content Policy. Not
            approved/endorsed by Wizards. Portions of the materials used are property of Wizards
            of the Coast. ©Wizards of the Coast LLC.
          </p>
          <p style={bodyStyle}>
            <a
              href="https://company.wizards.com/en/legal/fancontentpolicy"
              target="_blank"
              rel="noreferrer"
              style={linkStyle}
            >
              Read the Wizards of the Coast Fan Content Policy
            </a>
          </p>
        </div>

        <div style={sectionStyle}>
          <h2 style={headingStyle}>Card Data Attribution</h2>
          <p style={bodyStyle}>
            Card data, prices, and card images are provided by{' '}
            <a href="https://scryfall.com" target="_blank" rel="noreferrer" style={linkStyle}>
              Scryfall
            </a>
            . Card artwork is copyright the respective artists and Wizards of the Coast LLC.
          </p>
        </div>

        <div style={sectionStyle}>
          <h2 style={headingStyle}>Free Access to Magic: The Gathering Content</h2>
          <p style={bodyStyle}>
            All Magic: The Gathering content on CollectNDeck (including card search, set browsing,
            and rules reference) is freely accessible without registration. Account creation is
            optional and exists solely to enable personal-use features such as collection tracking
            and deck building, where a login is required to store and retrieve your own data.
            CollectNDeck does not restrict access to any Wizards of the Coast intellectual property
            behind a paywall, subscription, or mandatory registration.
          </p>
        </div>

        <div style={sectionStyle}>
          <h2 style={headingStyle}>Not Affiliated With Wizards of the Coast</h2>
          <p style={bodyStyle}>
            CollectNDeck is not affiliated with, endorsed by, or sponsored by Wizards of the Coast
            LLC. Magic: The Gathering and all related marks are trademarks of Wizards of the Coast
            LLC.
          </p>
        </div>
      </div>
    </>
  );
};

export default Legal;
